export const ONE_SECOND = 1000
export const ONE_MINUTE = 60 * ONE_SECOND
export const FIVE_MINUTES = 5 * ONE_MINUTE

export const SMART_ROUTING_RULE_TAG_PREFIX = "sr_rt_"
